// extracted by mini-css-extract-plugin
module.exports = {"budgetSettings":"src-components-BudgetBuilder-CostShare-Main-styles___budgetSettings"};